import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BarcodeServiceService {

  constructor() { }
  barcodeData: Subject<any> = new Subject<any>();

}
